import { RootfiCompanyUseCase } from '@commenda/prisma';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { RootfiSyncStatusResponse } from './types';

export function useRootfiSyncStatusSWR(
  corporationId: number,
  useCase?: RootfiCompanyUseCase
) {
  const baseUrl = corporationId
    ? `rootfi/sync-status/${corporationId}?useCase=${useCase ?? ''}`
    : null;

  const {
    data,
    error,
    mutate,
  }: {
    data?: RootfiSyncStatusResponse[];
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    baseUrl,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}
